import { QueryFunction, useQuery } from 'react-query';
import { getActivitiesTypes, GetActivitiesTypesQueries } from '../../services/apiSLTP/planning';
import { ActivityType } from '../../services/apiSLTP/dailyReports/activityTypes';

type UseActivitiesByDateAndStateQueryOptions = {
    queries?: GetActivitiesTypesQueries;
};

const getActivitiesTypesQuery: QueryFunction<ActivityType[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseActivitiesByDateAndStateQueryOptions];
    const { queries } = options;

    const response = await getActivitiesTypes(queries);
    return response.data;
};

export const useActivitiesTypesQuery = (options: UseActivitiesByDateAndStateQueryOptions) => {
    return useQuery(['activities types', options], getActivitiesTypesQuery);
};
